import React from "react";

import { images } from "../../../../assets";
import DicotomicCheckbox from "../../../../components/dicotomic-checkbox/dicotomic-checkbox";
import SelectBox from "../../../../components/select-box/select-box";
import { MascotasTableContainer } from "./mascotas-table-style";
import { MascotasTableProps } from "./mascotas-table-types";

const MascotasTable = ({
  formData,
  changeCoverage,
  changeValue,
  coveragesProps,
  rawCoverages,
}: MascotasTableProps) => {
  // coveragesProps son las coberturas del producto
  // coverages son el listado de coberturas por mascota
  if (!formData || !coveragesProps) return null;
  const { coverages, date } = formData;
  if (!coverages) return null;

  const deleteInsuredCoverages = (index: number) => {
    if (!formData) return;
    formData.coverages.splice(index, 1);
    changeValue(
      Number(formData.date.numPets.value) - 1 === 0 ? "" : Number(formData.date.numPets.value) - 1,
      "date",
      "numPets"
    );
  };

  const getClassNames = (): { main: string; complementary: string } => {
    const hasMainCovs = rawCoverages.some((cov) => cov.required);
    const hasComplementaryCovs = rawCoverages.some((cov) => !cov.required);
    const hasMainCapitals = rawCoverages.some((cov) =>
      cov.required && cov.capitales ? true : false
    );
    const hasComplementaryCapitals = rawCoverages.some((cov) =>
      !cov.required && cov.capitales ? true : false
    );

    if (hasMainCapitals && hasComplementaryCapitals) {
      return {
        main: "halfWidth",
        complementary: "halfWidth",
      };
    }

    if (hasMainCovs && !hasComplementaryCovs) {
      return {
        main: "fullWidth",
        complementary: "noWidth",
      };
    }

    return {
      main: "oneThirdWidth",
      complementary: "twoThirdWidth",
    };
  };

  const classNames = getClassNames();

  return (
    <MascotasTableContainer>
      {Array.from({ length: Number(date.numPets.value) }).map((_, index) => (
        <div className="personal-data-container mb-10" key={index}>
          <div className="col-100 borderB-white">
            <div className="col-25 table-bgBlue content-wrapper">Mascota {index + 1}</div>
          </div>

          <div className={`${classNames.main} table-tr mr-2per`}>
            <p className="table-bgBlue content-wrapper">
              {coveragesProps.main.title.toUpperCase()}
            </p>
            {coveragesProps.main.items.map((item) => {
              const coverage = coverages[index][item.code];
              if (!coverage) return null;
              const coverageCapital = coverage.capital;
              return (
                <div key={item.code} className="coverage-content">
                  <div className="content-wrapper">
                    <p>{item.name}</p>
                  </div>
                  {coverageCapital && (
                    <div className="h-auto">
                      <div className="selectBox flex flex-no-wrap">
                        <label className="point">&nbsp;</label>
                        <SelectBox
                          placeholder="Seleccionar capital"
                          required={true}
                          errorCode={coverageCapital.errorCode}
                          optionsText={coverage.options as { label: string; value: string }[]}
                          initialValue={coverageCapital.value}
                          defaultValue={coverageCapital.value}
                          optionKey={"value"}
                          optionValue={"label"}
                          onChange={(value: string) =>
                            value != "" &&
                            changeCoverage(value, "coverages", item.code, index, true)
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {coveragesProps.complementary.items.length > 0 && (
            <div className={`${classNames.complementary} table-tr`}>
              <p className="table-bgBlue content-wrapper">
                {coveragesProps.complementary.title.toUpperCase()}
              </p>
              <div>
                {coveragesProps.complementary.items.map((item, i: number) => {
                  const coverage = coverages[index][item.code];
                  return (
                    <div
                      className={
                        coverages[index][item.code].value === true
                          ? "flex-space-between plr-20"
                          : " flex-space-between content-wrapper"
                      }
                      key={i}
                    >
                      <DicotomicCheckbox
                        initChecked={coverages[index][item.code].value}
                        disabled={item.disabled || formData.isReadOnly}
                        className={
                          coverages[index][item.code].value === true ? "optional pt-10" : "optional"
                        }
                        checkboxText={item.name}
                        onChange={(value: string) => {
                          changeCoverage(value, "coverages", item.code, index);
                        }}
                      />
                      {coverage.value === true && coverage.capital && (
                        <div className="h-auto">
                          <div className="selectBox flex flex-no-wrap">
                            <label className="point">&nbsp;</label>
                            <SelectBox
                              placeholder="Seleccionar capital"
                              required={true}
                              errorCode={coverage.capital.errorCode}
                              optionsText={coverage.options as { label: string; value: string }[]}
                              initialValue={coverage.capital.value}
                              defaultValue={coverage.capital.value}
                              optionKey={"value"}
                              optionValue={"label"}
                              onChange={(value: string) =>
                                value != "" &&
                                changeCoverage(value, "coverages", item.code, index, true)
                              }
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <div className="colSin-4 flex align-center justify-center">
            <img
              className="colSin-60 pointer"
              src={images.IconDeleteBlue}
              onClick={() => deleteInsuredCoverages(index)}
              alt=""
            />
          </div>
        </div>
      ))}
    </MascotasTableContainer>
  );
};

export default MascotasTable;
